import React from 'react';
import { useQuerySet } from '~/contexts/QuerysetContext';
import { MobileLayout_S } from '~/core/configuration/configuration-global-config.schema';
import { ResultCategory } from '~/core/results/types/results.type';
import { useSERPState } from '~/core/state/SERPStateContext';
import { GoToResultHandler } from '~/hooks/useGoToResult';
import { useShownAttributes } from '~/hooks/useShownAttributes';
import SanitizedHTML from '~/utils/components/SanitizedHTML';
import getResultTitle from '~/utils/getResultTitle';
import styles from './category.module.scss';
import CategoryImage from './CategoryImage';

interface ICategory {
    result: ResultCategory;
    handleGoToResult: GoToResultHandler;
    order: number;
}

const Category: React.FC<ICategory> = ({ result, handleGoToResult, order }) => {
    const { config } = useSERPState();
    const { state: querySetState } = useQuerySet();
    const { shouldRenderKey } = useShownAttributes({ querySetState });

    const isNotInTabs = config.mobileLayout !== MobileLayout_S.Values.tabs;

    return (
        <li className={`${styles.category} ${isNotInTabs ? styles.notInTabs : ''}`} data-testid="categories-result">
            <div
                className={styles.categoryLink}
                role="link"
                tabIndex={0}
                onMouseDown={(e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    handleGoToResult({
                        url: result.url,
                        order,
                        resultType: 'category',
                        openInNewTab: e.button === 1 || (e.button === 0 && e.ctrlKey),
                        button: e.button,
                        key: e.ctrlKey ? 'ctrl' : undefined,
                    });
                }}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        e.preventDefault();
                        e.stopPropagation();
                        handleGoToResult({ url: result.url, order, resultType: 'category', key: 'Enter' });
                    }
                }}
            >
                {shouldRenderKey('image') && result.image ? (
                    <span className={styles.categoryImage}>
                        <CategoryImage url={result.image} />
                    </span>
                ) : null}
                <div className={styles.categoryLinkText}>
                    <SanitizedHTML html={getResultTitle(result)} />
                </div>
            </div>
        </li>
    );
};

export default Category;
